/**
 * HOW TO USE:
 * require('./lib/toast');
 * $.toast("你的文案哦");
 */
class Toast {
  constructor() {
    this.stack = [];
    this.currentText = '';
    this.active = false;
    this.timeId = -1;
  }

  init() {
    this.$element = $('<div id="toast" class="toast-container"></div>');
    this.$element.css({
      'display': 'none',
      'position': 'fixed',
      'max-width': '4.8rem',
      'padding': '.15rem .15rem',
      'background-color': 'rgba(0, 0, 0, .7)',
      'text-align': 'center',
      'color': '#fff',
      'border-radius': '.1rem',
      'top': '44%',
      'z-index': '99',
      '-webkit-transition': 'opacity .6s',
      'transition': 'opacity .6s',
      'font-size': '.28rem',
      'font-weight': 'bold',
      'line-height': '1.4'
    })
    this.vw = $(window).width();
    this.appendDom();
  }

  appendDom() {
    $(document.body).append(this.$element);
  }

  show(text) {
    const me = this;
    // 如果当前toast还在显示
    if (text == this.currentText && this.active) {
      clearTimeout(this.ctimeId);
      this.ctimeId = setTimeout(() => {
        me.hide();
        if (me.stack.length) {
          me._show();
        } else {
          me.active = false;
        }
      }, 2500);
    } else {
      this.stack.push(text);
      if (!this.active) {
        this.active = true;
        this._show();
      }
    }
  }

  _show() {
    const me = this;
    const text = this.stack.shift();
    if (!this.$element) {
      clearInterval(me.ctimeId);
      this.init();
    }
    this.$element.show();
    // if (this.currentText != text) {
    this.currentText = text;
    const w = this.$element.html(text).width();
    this.$element.css({
      left: `${(this.vw - w) / 2}px`,
      opacity: 1
    });
    // }
    clearTimeout(this.ctimeId);
    this.ctimeId = setTimeout(() => {
      me.hide();
      if (me.stack.length) {
        me._show();
      } else {
        me.active = false;
      }
    }, 2500);
  }

  hide() {
    this.$element.css({
      display: 'none',
      opacity: 0
    });
  }
}

const toast = new Toast();

export default toast.show.bind(toast);
